@let isLoading = isLoading$ | async;
@let integrationsCards = integrationsCards$ | async;

@if (isLoading === false) {
    <div class="integrations">
        <div class="cards-actions">
            <!-- Needed for MS -->
            @if (userService.loggedInUser["org_id"] === "org_5gmD9cRGrozzVaxH") {
                <app-anchor-link navigation="https://go.microsoft.com/fwlink/?LinkId=521839" class="microsoft-privacy-statement">
                    Microsoft Privacy Statement
                </app-anchor-link>
            }

            <div class="add-button-container">
                <app-button
                    [isEnabled]="
                        (integrationsCards?.length ?? 0) < this.maxIntegrations && this.permissionsService.hasPermissions(this.permissionsEnum.admin)
                    "
                    buttonIconPath="assets/images/common/plus.svg"
                    tooltipPosition="left"
                    [disabledTooltipText]="disabledAddIntegrationButtonReason"
                    (buttonClicked)="addIntegration()"
                    buttonTextLabelPath="integrationsPage.addButton"></app-button>
            </div>
        </div>

        @if ((integrationsCards?.length ?? 0) > 0) {
            <div class="integrations-cards">
                @for (card of integrationsCards; track card.cardId) {
                    <app-info-card
                        [card]="card"
                        (cardOnClick)="actionOnClick($event)"
                        [isIntegrationsScansDataFeatureEnabled]="isIntegrationsScansDataFeatureEnabled()">
                    </app-info-card>
                }
            </div>
        } @else {
            <app-no-data></app-no-data>
        }
    </div>
} @else {
    <div class="integrations-spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
}
